function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#4A4A4A",
  d: "M21.82 11.36L17.18 16l4.64 4.64-1.18 1.18L16 17.18l-4.64 4.64-1.18-1.18L14.82 16l-4.64-4.64 1.18-1.18L16 14.82l4.64-4.64z",
  fillRule: "evenodd"
})));